<shared-ui-modal-base-modal
  [cancelButtonTitle]="'button-cancel' | translate"
  [confirmButtonTitle]="'button-confirm' | translate"
  [confirmButtonDisabled]="reactiveForm.invalid"
  [canConfirm]="true"
  [title]="'modal-change-password-title' | translate"
  (confirmOutput)="saveData()"
>
  <form [formGroup]="reactiveForm">
    <shared-ui-inputs-input-group
      [parentFormGroup]="reactiveForm"
      [type]="type"
      [formName]="'password'"
      [name]="'input-new-password' | translate"
      [display]="display"
    ></shared-ui-inputs-input-group>
    <br />
    <shared-ui-inputs-input-group
      [parentFormGroup]="reactiveForm"
      [type]="type"
      [formName]="'confirmPassword'"
      [name]="'input-confirm-password' | translate"
      [display]="display"
    ></shared-ui-inputs-input-group>
  </form>
  <div class="row">
    <div class="col-sm-2"></div>
    <div class="col-sm-10">
      <div *ngIf="reactiveForm.hasError('notMatch')">
        <div class="invalid-feedback d-block">{{ 'default-not-matched-field' | translate }}</div>
      </div>
    </div>
  </div>
</shared-ui-modal-base-modal>
